// extracted by mini-css-extract-plugin
export default {"SideMenu":"_SideMenu--FL4I8","Mobile":"_Mobile--hLItZ","WrapperDiv":"_WrapperDiv--jh4uK"};